export const NEW_BADGE_COLOR = "#d32f2f";
export const NEW_BADGE_ICON_COLOR = "#d32f2f";